import React from "react";
import { Card, Typography } from "@material-tailwind/react";

interface ErrorLoadingStateProps {
  errorMessage?: string;
}

const ErrorLoadingState: React.FC<ErrorLoadingStateProps> = ({
  errorMessage = "An error occurred while loading data.",
}) => {
  return (
    <Card placeholder={undefined} className="mt-14">
      <div className="p-4">
        <Typography placeholder={undefined} variant="h5" color="red">
          Error
        </Typography>
        <Typography placeholder={undefined} variant="paragraph" color="gray">
          {errorMessage}
        </Typography>
      </div>
    </Card>
  );
};

export default ErrorLoadingState;
